import React, { useState, useRef, useEffect } from 'react';
import {
    Alert,
    Box,
    Checkbox,
    Chip,
    TextField,
    Drawer,
    FormControlLabel,
    Grid,
    Select,
    IconButton,
    MenuItem,
    Paper,
    Typography,
    Button,
    OutlinedInput,
    ListItemButton,
    InputAdornment,
    List,
    ListItem,
    Tabs,
    Tab,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';

import { makeStyles } from '@mui/styles';
import useTheme from '@mui/material/styles/useTheme';
import { IconSearch, IconArrowLeft, IconX } from '@tabler/icons';

import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';

import api from '../../../services/api';
import { encodePathSegments } from '../../../../utils/media-url';
import { formatCurrencyBRL, formatImovelPrice } from '../../../../utils/currency';
import { isFieldVisible } from '../configuracoes/shared/fieldVisibility';
import CustomFieldInput from '../configuracoes/shared/CustomFieldInput';
import RelatedTicketsSection from '../../ticket/RelatedTicketsSection';
import ContratoFormDrawer from '../../servico/ContratoFormDrawer';
import ContratoDetailDrawer from '../../servico/ContratoDetailDrawer';

const IMOVEL_STATUS_LABELS = {
    disponivel: 'Disponível',
    reservado: 'Reservado',
    vendido: 'Vendido',
    alugado: 'Alugado',
    indisponivel: 'Indisponível',
    pendente: 'Pendente',
    encerrado: 'Encerrado'
};

const VISITA_STATUS_LABELS = { agendada: 'Agendada', realizada: 'Realizada', cancelada: 'Cancelada' };

const CONTRATO_STATUS_LABELS = { rascunho: 'Rascunho', assinado: 'Assinado', ativo: 'Ativo', encerrado: 'Encerrado', renovado: 'Renovado' };
const CONTRATO_TIPO_LABELS = { venda: 'Venda', aluguel: 'Aluguel' };

// style constant
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex'
    },
    appBar: {
        backgroundColor: '#2B2C4A', //theme.palette.background.default,
        zIndex: theme.zIndex.drawer + 1,
        height: 48,
        transition: theme.transitions.create(['top'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    conversationBar: {
        background: '#161818',
        color: '#e60000'
    },
    toolbar: {
        minHeight: 48
    },
    appBarWidth: {
        transition: theme.transitions.create('width'),
        backgroundColor: theme.palette.background.default
    },
    content: {
        ...theme.typography.mainContent,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            // marginLeft: -(drawerWidth - 20),
            // width: `calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px',
            // width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            // width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px',
            marginRight: '10px'
        }
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    }
}));

function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name) {
    if (!name.includes(' ')) {
        return {
            sx: {
                bgcolor: stringToColor(name),
                color: '#FFFFFF'
            },
            children: `${name[0]}`
        };
    }
    return {
        sx: {
            bgcolor: stringToColor(name)
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
    };
}

const DadosDeal = ({
    status_drawer,
    onCloseDrawer,
    onVoltarParaChat,
    conversa_selecionada,
    mensagens,
    appId,
    conversa_lida,
    deal,
    onDealChange,
    onDealsChanged,
    pipelineId,
    integration_id
}) => {
    const [status, setStatus] = useState({ type: '', message: '' });

    const [solicitouDadosConversa, setSolicitouDadosConversa] = useState(false);

    const [dealNew, setDealNew] = useState(deal || {});
    const [stages, setStages] = useState([]);

    //? Default
    const [pipelineIdDefault, setPipelineIdDefault] = useState(null);
    const [stageIdDefault, setStageIdDefault] = useState(null);
    const [integrationId, setIntegrationId] = useState(null);

    //? Mover negócio para outro Pipeline
    const [movePipelineOpen, setMovePipelineOpen] = useState(false);
    const [pipelinesList, setPipelinesList] = useState([]);
    const [targetPipelineId, setTargetPipelineId] = useState('');
    const [targetStages, setTargetStages] = useState([]);
    const [targetStageId, setTargetStageId] = useState('');
    const [movingPipeline, setMovingPipeline] = useState(false);

    //? Mover conversa pra outra equipe
    const [moveTeamOpen, setMoveTeamOpen] = useState(false);
    const [equipesList, setEquipesList] = useState([]);
    const [targetTeamId, setTargetTeamId] = useState('');
    const [movingTeam, setMovingTeam] = useState(false);

    //? Organização
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [organizationSelecionada, setOrganizationSelecionada] = useState(null);

    //? Cliente
    const [searchClientTerm, setSearchClientTerm] = useState('');
    const [searchClientResults, setSearchClientResults] = useState([]);
    const [showClientResults, setShowClientResults] = useState(false);
    const [clienteSelecionado, setClienteSelecionado] = useState(null);

    //? Atribuído
    const [searchAssignTerm, setSearchAssignTerm] = useState('');
    const [searchAssignResults, setSearchAssignResults] = useState([]);
    const [showAssignResults, setShowAssignResults] = useState(false);
    const [AtribuidoSelecionado, setAtribuidoSelecionado] = useState(null);

    //? Order
    const [tab, setTab] = useState(0);
    const [orderExists, setOrderExists] = useState(false);
    const [openProductModal, setOpenProductModal] = useState(false);
    const [productModalTipo, setProductModalTipo] = useState('produto');
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedVariacao, setSelectedVariacao] = useState(null);
    const [servicos, setServicos] = useState([]);
    const [selectedServico, setSelectedServico] = useState(null);
    const [quantity, setQuantity] = useState(1);

    const [loadingItems, setLoadingItems] = useState({});
    const debounceTimers = useRef({});

    const [order, setOrder] = useState(null);

    //? Imóvel (contas do tipo "imobiliaria" - substitui a aba de Produtos)
    const [accountType, setAccountType] = useState(null);
    const [linkedImovel, setLinkedImovel] = useState(null);
    const [openImovelPicker, setOpenImovelPicker] = useState(false);
    const [imoveis, setImoveis] = useState([]);
    const [imovelSearchTerm, setImovelSearchTerm] = useState('');
    const [visitas, setVisitas] = useState([]);
    const [contratos, setContratos] = useState([]);
    const [openVisitaModal, setOpenVisitaModal] = useState(false);
    const [visitaForm, setVisitaForm] = useState({ start: '', end: '', status: 'agendada' });
    const [openContratoModal, setOpenContratoModal] = useState(false);
    const [contratoForm, setContratoForm] = useState({ tipo: 'venda', valor: '', data_inicio: '', data_fim: '', status: 'rascunho' });

    //? Contrato de Serviço (vinculado ao Deal) - módulo aditivo, só aparece
    // se a conta tem `services_enabled` (ligado em Ajustes da Conta). Nome
    // da state deliberadamente diferente de `contratos` acima (que é do
    // Contrato imobiliário, entidade totalmente diferente) pra não colidir.
    const [servicesEnabled, setServicesEnabled] = useState(false);
    const [contratosServico, setContratosServico] = useState([]);
    const [openContratoServicoForm, setOpenContratoServicoForm] = useState(false);
    const [contratoServicoDetailId, setContratoServicoDetailId] = useState(null);

    //? Proposta (vinculada ao Deal) - "modelo" é só o conjunto de campos
    // personalizados configurado de antemão em Ajustes da Conta.
    const [propostas, setPropostas] = useState([]);
    const [propostaFieldsConfig, setPropostaFieldsConfig] = useState([]);
    const [openPropostaForm, setOpenPropostaForm] = useState(false);
    const [propostaForm, setPropostaForm] = useState({ titulo: '', fields: {} });
    const [savingProposta, setSavingProposta] = useState(false);
    const [propostaActionLoading, setPropostaActionLoading] = useState({});
    // Prévia do PDF (visualizar sozinho, ou revisar antes de confirmar o
    // envio pro cliente) - mesma proposta serve pros dois casos, o que muda
    // é `previewParaEnviar` (mostra o botão "Confirmar e enviar" dentro do
    // preview em vez de só "Fechar").
    const [previewProposta, setPreviewProposta] = useState(null);
    const [previewParaEnviar, setPreviewParaEnviar] = useState(false);

    const [form, setForm] = useState({
        title: 'Novo Negócio',
        value: 0,
        description: '',
        stage: '',
        user: '',
        organization: '',
        conversation: '',
        assign: ''
    });
    const [negocio, setNegocio] = useState({});
    const [dealFieldsConfig, setDealFieldsConfig] = useState([]);
    const [dealFields, setDealFields] = useState({});

    //? Histórico de negócios da conversa (deals antigos, já encerrados)
    const [dealHistory, setDealHistory] = useState([]);
    const [showDealHistory, setShowDealHistory] = useState(false);
    const [savingOutcome, setSavingOutcome] = useState(false);
    const [dismissedOutcomeBannerDealId, setDismissedOutcomeBannerDealId] = useState(null);

    useEffect(() => {
        if (!deal) return;

        setForm({
            title: deal.title || '',
            value: deal.value || 'R$ 0,00',
            description: deal.description || '',
            stage: deal.stage || '',
            user: deal.user || '',
            organization: deal.organization || '',
            conversation: deal.conversation || '',
            assign: deal.assign || ''
        });

        // 👤 Cliente
        if (deal.user_detail) {
            setClienteSelecionado(deal.user_detail);
            setSearchClientTerm(`${deal.user_detail.first_name} ${deal.user_detail.last_name}`);
        } else {
            setClienteSelecionado(null);
            setSearchClientTerm('');
        }

        // 👤 Atribuído
        if (deal.assign_detail) {
            setAtribuidoSelecionado(deal.assign_detail);
            setSearchAssignTerm(`${deal.assign_detail.first_name} ${deal.assign_detail.last_name}`);
        } else {
            setAtribuidoSelecionado(null);
            setSearchAssignTerm('');
        }

        // 🏢 Organização
        // preenche visualmente a organização
        if (deal.organization_detail) {
            setOrganizationSelecionada(deal.organization_detail);
            setSearchTerm(deal.organization_detail.name);
        } else {
            setOrganizationSelecionada(null);
            setSearchTerm('');
        }
    }, [deal]);

    useEffect(() => {
        setStatus({
            type: '',
            message: ''
        });
    }, [status_drawer]);

    useEffect(() => {
        if (!appId) return;
        (async () => {
            try {
                const res = await api.get('v1/apps/default/');
                setAccountType(res.data?.app?.account_type || null);
                setServicesEnabled(Boolean(res.data?.app?.services_enabled));
            } catch (err) {
                console.error(err);
            }
        })();
    }, [appId]);

    useEffect(() => {
        if (accountType !== 'imobiliaria') return;
        fetchLinkedImovel();
        fetchVisitas();
        fetchContratos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accountType, deal?.id, appId]);

    const fetchContratosServico = async () => {
        if (!appId || !deal?.id) return;
        try {
            const res = await api.get(`v1/apps/${appId}/contratos_servico/?deal=${deal.id}`);
            setContratosServico(res.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (!servicesEnabled) return;
        fetchContratosServico();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [servicesEnabled, deal?.id, appId]);

    const fetchPropostas = async () => {
        if (!appId || !deal?.id) return;
        try {
            const res = await api.get(`v1/apps/${appId}/propostas/?deal=${deal.id}`);
            setPropostas(res.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchPropostas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deal?.id, appId]);

    useEffect(() => {
        if (!appId) return;
        api
            .get(`v1/apps/${appId}/proposta_fields/`)
            .then((res) => setPropostaFieldsConfig(res.data || []))
            .catch((err) => console.error(err));
    }, [appId]);

    const fetchDeal = async () => {
        if (!deal?.id) return;
        if (!appId) return;
        if (!pipelineId) return;
        const res = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/deals/${deal.id}/`);

        setNegocio(res.data.deal);
    };

    useEffect(() => {
        if (!appId || !pipelineId) return;
        api.get(`v1/apps/${appId}/pipelines/${pipelineId}/deal_fields/`)
            .then((r) => setDealFieldsConfig(r.data || []))
            .catch(console.error);
    }, [appId, pipelineId]);

    useEffect(() => {
        // roda só quando o id muda (não a cada poll de 3s do fetchDeal),
        // senão qualquer edição de campo customizado em andamento seria
        // sobrescrita antes do usuário conseguir salvar
        if (!negocio?.fields) {
            setDealFields({});
            return;
        }
        setDealFields(Object.fromEntries(negocio.fields.map((f) => [f.name, f.value])));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [negocio?.id]);

    const handleChangeSearch = async (e) => {
        if (!appId) return;
        const value = e.target.value;
        setSearchTerm(value);

        if (value.length < 2) {
            setShowResults(false);
            return;
        }

        try {
            const response = await api.get(`v1/apps/${appId}/organizations/?search=${value}`);
            setSearchResults(response.data.organizations);
            setShowResults(true);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSelectOrganization = (org) => {
        setOrganizationSelecionada(org);
        setSearchTerm(org.name);
        setShowResults(false);

        setForm((prev) => ({
            ...prev,
            organization: org.id
        }));
    };

    const clearOrganization = () => {
        setOrganizationSelecionada(null);
        setSearchTerm('');
        setShowResults(false);

        setForm((prev) => ({
            ...prev,
            organization: null
        }));
    };

    const handleChangeSearchUsers = async (e) => {
        if (!appId) return;
        const value = e.target.value;
        setSearchClientTerm(value);

        if (value.length < 2) {
            setShowClientResults(false);
            return;
        }

        try {
            const response = await api.get(`v1/apps/${appId}/users/?search=${value}`);
            setSearchClientResults(response.data.users);
            setShowClientResults(true);
        } catch (error) {
            console.error(error);
        }
    };

    const handleChangeSearchClient = async (e) => {
        if (!appId) return;
        const value = e.target.value;
        setSearchClientTerm(value);

        if (value.length < 2) {
            setShowClientResults(false);
            return;
        }

        try {
            const response = await api.get(`v1/apps/${appId}/users/?search=${value}`);
            setSearchClientResults(response.data.users);
            setShowClientResults(true);
        } catch (error) {
            console.error(error);
        }
    };

    const handleChangeSearchAssign = async (e) => {
        if (!appId) return;
        const value = e.target.value;
        setSearchAssignTerm(value);

        if (value.length < 2) {
            setShowAssignResults(false);
            return;
        }

        try {
            const response = await api.get(`users/?search=${value}`);
            setSearchAssignResults(response.data);
            setShowAssignResults(true);
        } catch (error) {
            console.error(error);
        }
    };

    const getDefaultIdPipeline = async () => {
        if (!appId) return;
        try {
            const response = await api.get(`v1/apps/${appId}/pipelines/?default=true`);
            if (response.data && response.data.length > 0) {
                // console.log(`Default Pipeline: ${JSON.stringify(response.data[0])}`);
                setPipelineIdDefault(response.data[0].id);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getDefaultIdPipeline();
    }, []);

    const getDefaultIdStage = async () => {
        if (!appId) return;
        try {
            const response = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/stages/?default=true`);
            if (response.data && response.data.length > 0) {
                console.log(`Default Stage: ${JSON.stringify(response.data[0])}`);
                setStageIdDefault(response.data[0].id);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getDefaultIdStage();
    }, []);

    const handleSelectClient = (user) => {
        setClienteSelecionado(user);
        setSearchClientTerm(`${user.first_name} ${user.last_name}`);
        setShowClientResults(false);

        setForm((prev) => ({
            ...prev,
            user: user.id //  só o ID vai pro backend
        }));
    };

    const clearClient = () => {
        setClienteSelecionado(null);
        setSearchClientTerm('');
        setShowClientResults(false);

        setForm((prev) => ({
            ...prev,
            user: null
        }));
    };

    const handleSelectAssign = (user) => {
        setAtribuidoSelecionado(user);
        setSearchAssignTerm(`${user.first_name} ${user.last_name}`);
        setShowAssignResults(false);

        setForm((prev) => ({
            ...prev,
            assign: user.id
        }));
    };

    const clearAssign = () => {
        setAtribuidoSelecionado(null);
        setSearchAssignTerm('');
        setShowAssignResults(false);

        setForm((prev) => ({
            ...prev,
            assign: null
        }));
    };

    const listarProdutos = async () => {
        const res = await api.get(`v1/apps/${appId}/catalog_items/?tipo=produto&limit=200`);
        setProducts(res.data?.results || []);
    };

    const listarServicos = async () => {
        const res = await api.get(`v1/apps/${appId}/catalog_items/?tipo=servico&ativo=true&limit=200`);
        setServicos(res.data?.results || []);
    };

    // A listagem usa o serializer leve (sem `variacoes` aninhado, desde a
    // unificação Produto+Serviço em Item) - busca o detalhe completo ao
    // selecionar um produto no modal, pra poder listar as variações dele.
    const handleSelectProduct = async (p) => {
        try {
            const res = await api.get(`v1/apps/${appId}/catalog_items/${p.id}/`);
            setSelectedProduct(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleAddProduct = async () => {
        try {
            // Produto usa `variacao` (sempre tem); Serviço usa `item`
            // direto (nunca tem variação, preço vem do próprio Item).
            const itemPayload =
                productModalTipo === 'produto' ? { variacao: selectedVariacao.id, quantity } : { item: selectedServico.id, quantity };

            // se já existe order → adiciona item
            if (deal?.orders?.length > 0) {
                const orderId = deal.orders[0].id;
                await api.post(`v1/apps/${appId}/orders/${orderId}/items/`, itemPayload);
            } else {
                // fallback: cria order
                const payload = {
                    deal: deal.id,
                    user: form.user || null,
                    organization: form.organization || null,
                    items: [itemPayload]
                };

                const res = await api.post(`v1/apps/${appId}/orders/`, payload);

                setOrder(res.data);
            }

            await fetchDeal();

            setOpenProductModal(false);
            setSelectedProduct(null);
            setSelectedVariacao(null);
            setSelectedServico(null);
            setQuantity(1);
        } catch (err) {
            console.error(err);
        }
    };

    //? Proposta - criada direto no drawer do Deal: a atendente preenche os
    // campos já configurados em Ajustes da Conta, salva, gera o PDF e pode
    // enviar na conversa.
    const handleCreateProposta = async () => {
        setSavingProposta(true);
        try {
            await api.post(`v1/apps/${appId}/propostas/`, {
                deal: deal.id,
                titulo: propostaForm.titulo,
                fields: propostaForm.fields
            });
            setOpenPropostaForm(false);
            setPropostaForm({ titulo: '', fields: {} });
            await fetchPropostas();
        } catch (err) {
            console.error(err);
            setStatus({ type: 'error', message: err.response?.data?.error || 'Erro ao criar Proposta.' });
        } finally {
            setSavingProposta(false);
        }
    };

    const handleGerarPdfProposta = async (propostaId) => {
        setPropostaActionLoading((prev) => ({ ...prev, [propostaId]: 'pdf' }));
        try {
            await api.post(`v1/apps/${appId}/propostas/${propostaId}/gerar_pdf/`);
            await fetchPropostas();
        } catch (err) {
            console.error(err);
            setStatus({ type: 'error', message: 'Erro ao gerar PDF da Proposta.' });
        } finally {
            setPropostaActionLoading((prev) => ({ ...prev, [propostaId]: null }));
        }
    };

    // Reaproveita exatamente o mesmo mecanismo já usado pra reenviar um
    // documento salvo na conversa (`enviar_documento_existente` em
    // JanelaConversa.js) - POST direto com `document_id`, sem endpoint novo.
    const handleEnviarPropostaChat = async (proposta) => {
        if (!proposta.document || !conversa_selecionada?.id) return;
        setPropostaActionLoading((prev) => ({ ...prev, [proposta.id]: 'send' }));
        try {
            await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/messages/`, {
                document_id: proposta.document,
                author: { userId: '', avatarUrl: '', displayName: 'Nome Atendente', type: 'agent' },
                source: { originalMessageId: '', originalMessageTimestamp: '', type: 'file' }
            });
            await api.patch(`v1/apps/${appId}/propostas/${proposta.id}/`, { status: 'enviada' });
            await fetchPropostas();
        } catch (err) {
            console.error(err);
            setStatus({ type: 'error', message: 'Erro ao enviar Proposta no chat.' });
        } finally {
            setPropostaActionLoading((prev) => ({ ...prev, [proposta.id]: null }));
        }
    };

    // Abre a prévia do PDF direto no sistema (iframe, sem baixar nada) - só
    // pra olhar (`paraEnviar=false`) ou como etapa obrigatória de revisão
    // antes de confirmar o envio pro cliente (`paraEnviar=true`, mostra um
    // botão "Confirmar e enviar" dentro do próprio preview em vez de mandar
    // direto no clique de "Enviar no chat").
    const handleAbrirPreviewProposta = (proposta, paraEnviar) => {
        setPreviewProposta(proposta);
        setPreviewParaEnviar(paraEnviar);
    };

    const handleConfirmarEnvioProposta = async () => {
        if (!previewProposta) return;
        await handleEnviarPropostaChat(previewProposta);
        setPreviewProposta(null);
        setPreviewParaEnviar(false);
    };

    //? Media (fotos de imóvel)
    const BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:8000/api/';
    const getPrivateMediaUrl = (path) => {
        if (!path || !appId) return '';
        return `${BACKEND_SERVER}v1/apps/${appId}/media/${encodePathSegments(path)}`;
    };

    //? Imóvel vinculado ao Deal (contas imobiliária)
    const fetchLinkedImovel = async () => {
        if (!appId || !deal?.id) return;
        try {
            const res = await api.get(`v1/apps/${appId}/deals/${deal.id}/imovel/`);
            setLinkedImovel(res.data.imovel || null);
        } catch (err) {
            console.error(err);
        }
    };

    const listarImoveis = async () => {
        try {
            const res = await api.get(`v1/apps/${appId}/imoveis/`);
            setImoveis(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleLinkImovel = async (imovel) => {
        try {
            await api.put(`v1/apps/${appId}/deals/${deal.id}/imovel/`, { imovel: imovel.id });
            setOpenImovelPicker(false);
            setImovelSearchTerm('');
            await fetchLinkedImovel();
        } catch (err) {
            console.error(err);
        }
    };

    const handleUnlinkImovel = async () => {
        try {
            await api.delete(`v1/apps/${appId}/deals/${deal.id}/imovel/`);
            setLinkedImovel(null);
        } catch (err) {
            console.error(err);
        }
    };

    const imoveisFiltrados = imoveis.filter((i) => normalizarBusca(i.titulo).includes(normalizarBusca(imovelSearchTerm)));

    function normalizarBusca(value) {
        return (value || '').toString().toLowerCase();
    }

    //? Visitas do Deal
    const fetchVisitas = async () => {
        if (!appId || !deal?.id) return;
        try {
            const res = await api.get(`v1/apps/${appId}/visitas/?deal_id=${deal.id}`);
            setVisitas(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleCreateVisita = async () => {
        try {
            await api.post(`v1/apps/${appId}/visitas/`, {
                imovel: linkedImovel.id,
                deal: deal.id,
                start: visitaForm.start,
                end: visitaForm.end,
                status: visitaForm.status
            });
            setOpenVisitaModal(false);
            setVisitaForm({ start: '', end: '', status: 'agendada' });
            await fetchVisitas();
        } catch (err) {
            console.error(err);
        }
    };

    //? Contratos do Deal
    const fetchContratos = async () => {
        if (!appId || !deal?.id) return;
        try {
            const res = await api.get(`v1/apps/${appId}/contratos/?deal_id=${deal.id}`);
            setContratos(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleCreateContrato = async () => {
        try {
            await api.post(`v1/apps/${appId}/contratos/`, {
                imovel: linkedImovel.id,
                deal: deal.id,
                tipo: contratoForm.tipo,
                valor: contratoForm.valor || 0,
                data_inicio: contratoForm.data_inicio || null,
                data_fim: contratoForm.data_fim || null,
                status: contratoForm.status
            });
            setOpenContratoModal(false);
            setContratoForm({ tipo: 'venda', valor: '', data_inicio: '', data_fim: '', status: 'rascunho' });
            await fetchContratos();
        } catch (err) {
            console.error(err);
        }
    };

    const tamanhoTelaConversa = solicitouDadosConversa ? '60%' : '100%';
    const [ordersState, setOrdersState] = useState([]);

    const [orderStateAtual, setOrderStateAtual] = useState({});

    useEffect(() => {
        if (deal?.orders) {
            setOrdersState(deal.orders);
            setOrderStateAtual(deal.orders[0]);
        }
    }, [deal]);

    useEffect(() => {
        if (negocio?.orders) {
            setOrdersState(negocio.orders);
            setOrderStateAtual(negocio.orders[0]);
        }
    }, [negocio]);

    //? TEMA
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const formatDateBR = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getStages = async () => {
        if (!appId) return;
        try {
            const response = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/stages/`);
            if (response.data) {
                setStages(response.data);
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao buscar fases!'
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getStages();
    }, [deal]);

    const createDeal = async () => {
        const payload = {
            pipeline: pipelineIdDefault,
            title: form.title,
            value: form.value,
            description: form.description,
            stage: stageIdDefault,
            user: form.user,
            organization: form.organization,
            assign: form.assign
        };

        const cleanPayload = Object.fromEntries(Object.entries(payload).filter(([_, v]) => v !== null && v !== undefined));
        if (!pipelineId) return;
        console.log(`JanelaConversa - createDeal - cleanPayload: ${JSON.stringify(cleanPayload)}`);
        console.log(`JanelaConversa - createDeal - url:v1/apps/${appId}/pipelines/${pipelineId}/deals/`);

        const visibleDealFieldNames = new Set(
            dealFieldsConfig.filter((f) => isFieldVisible(f, dealFieldsConfig, dealFields)).map((f) => f.name)
        );
        const dealFieldsToSend = Object.fromEntries(Object.entries(dealFields).filter(([name]) => visibleDealFieldNames.has(name)));

        const response = await api.post(`v1/apps/${appId}/pipelines/${pipelineId}/deals/`, { deal: cleanPayload, fields: dealFieldsToSend });

        console.log(`JanelaConversa - createDeal - response:${JSON.stringify(response)}`);

        return response.data;
    };

    const attachDealToConversation = async (dealId) => {
        return api.patch(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/`, { deal: dealId });
    };

    const updateDeal = async () => {
        console.log(`updateDeal - entrou`);
        const visibleDealFieldNames = new Set(
            dealFieldsConfig.filter((f) => isFieldVisible(f, dealFieldsConfig, dealFields)).map((f) => f.name)
        );
        const dealFieldsToSend = Object.fromEntries(Object.entries(dealFields).filter(([name]) => visibleDealFieldNames.has(name)));

        const payload = {
            title: form.title,
            value: form.value,
            description: form.description,
            stage: form.stage,
            user: form.user,
            organization: form.organization,
            assign: form.assign,
            fields: dealFieldsToSend
        };

        if (!pipelineId) return;

        return api.patch(`v1/apps/${appId}/pipelines/${pipelineId}/deals/${deal.id}/`, payload);
    };

    const handleSaveDeal = async () => {
        console.log('handleSaveDeal - form:', form);

        try {
            // CRIAR
            if (!deal) {
                if (!form.title) {
                    setStatus({ type: 'error', message: 'Título é obrigatório' });
                    return;
                }

                const newDeal = await createDeal();

                setDealNew(newDeal.id);

                await attachDealToConversation(newDeal.id);

                onDealChange?.(newDeal);
                onDealsChanged?.();

                flashStatus({
                    type: 'success',
                    message: 'Negócio criado e vinculado com sucesso!'
                });

                return;
            }

            // ATUALIZAR
            await updateDeal();
            onDealsChanged?.();

            flashStatus({
                type: 'success',
                message: 'Negócio atualizado com sucesso!'
            });
        } catch (error) {
            console.error('Erro ao salvar negócio:', error);

            flashStatus({
                type: 'error',
                message: 'Erro ao salvar negócio!'
            });
        }
    };

    const flashStatus = (status) => {
        setStatus(status);
        setTimeout(() => setStatus({ type: '', message: '' }), 4000);
    };

    const limparSelecoesForm = () => {
        setClienteSelecionado(null);
        setSearchClientTerm('');
        setAtribuidoSelecionado(null);
        setSearchAssignTerm('');
        setOrganizationSelecionada(null);
        setSearchTerm('');
    };

    const fetchDealHistory = async () => {
        if (!appId || !conversa_selecionada?.id) return;
        try {
            const response = await api.get(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/deals/`);
            setDealHistory(response.data || []);
        } catch (error) {
            console.error('Erro ao buscar histórico de negócios', error);
        }
    };

    const toggleDealHistory = async () => {
        const next = !showDealHistory;
        setShowDealHistory(next);
        if (next) await fetchDealHistory();
    };

    const handleReabrirNegocio = async () => {
        if (!deal?.id || !pipelineId) return;
        try {
            setSavingOutcome(true);
            await api.patch(`v1/apps/${appId}/pipelines/${pipelineId}/deals/${deal.id}/`, {
                outcome: 'open',
                closed_at: null
            });
            onDealChange?.({ ...deal, outcome: 'open', closed_at: null });
            onDealsChanged?.();
            flashStatus({ type: 'success', message: 'Negócio reaberto!' });
        } catch (error) {
            console.error('Erro ao reabrir negócio', error);
            flashStatus({ type: 'error', message: 'Erro ao reabrir negócio!' });
        } finally {
            setSavingOutcome(false);
        }
    };

    //? Mover negócio para outro Pipeline - endpoint próprio
    // (`deal_move_pipeline`), não o PATCH normal de Deal, porque mudar de
    // pipeline tira o negócio do escopo do `pipelineId` atual (a URL de
    // edição normal é sempre `pipelines/{pipelineId}/deals/{id}/`).
    const openMovePipeline = async () => {
        setMovePipelineOpen(true);
        setTargetPipelineId('');
        setTargetStages([]);
        setTargetStageId('');
        try {
            const res = await api.get(`v1/apps/${appId}/pipelines/`);
            setPipelinesList((res.data || []).filter((p) => p.id !== pipelineId));
        } catch (error) {
            console.error('Erro ao buscar pipelines', error);
        }
    };

    const handleChangeTargetPipeline = async (newPipelineId) => {
        setTargetPipelineId(newPipelineId);
        setTargetStageId('');
        if (!newPipelineId) {
            setTargetStages([]);
            return;
        }
        try {
            const res = await api.get(`v1/apps/${appId}/pipelines/${newPipelineId}/stages/`);
            setTargetStages(res.data || []);
            setTargetStageId(res.data?.[0]?.id || '');
        } catch (error) {
            console.error('Erro ao buscar etapas do pipeline de destino', error);
        }
    };

    const handleMovePipeline = async () => {
        if (!deal?.id || !targetPipelineId) return;
        setMovingPipeline(true);
        try {
            await api.post(`v1/apps/${appId}/deals/${deal.id}/move_pipeline/`, {
                pipeline: targetPipelineId,
                stage: targetStageId || undefined
            });
            setMovePipelineOpen(false);
            onDealsChanged?.();
            flashStatus({ type: 'success', message: 'Negócio movido para outro pipeline!' });
            // O drawer estava vinculado ao pipeline antigo (`pipelineId`) -
            // como o negócio não pertence mais a ele, volta pro chat em vez
            // de manter uma tela de detalhe pra um negócio que já não bate
            // mais com esse pipeline.
            onVoltarParaChat?.();
        } catch (error) {
            console.error('Erro ao mover negócio de pipeline', error);
            flashStatus({ type: 'error', message: error.response?.data?.error || 'Erro ao mover negócio de pipeline!' });
        } finally {
            setMovingPipeline(false);
        }
    };

    //? Mover conversa pra outra equipe - endpoint próprio
    // (`conversation_move_team`), não ligado a Deal/pipeline nenhum -
    // qualquer conversa pode ser movida de equipe, tenha ou não negócio.
    const openMoveTeam = async () => {
        setMoveTeamOpen(true);
        setTargetTeamId('');
        try {
            // `all=1` - mostra TODAS as equipes, não só as que o usuário faz
            // parte (o endpoint de listagem por padrão restringe pra quem
            // não é admin/manager, pensado pro filtro "Equipes" da tela de
            // Chats; mover conversa é diferente: quem está atendendo pode
            // perceber que o assunto é de outra equipe mesmo sem fazer
            // parte dela e precisa poder redirecionar pra qualquer uma).
            const res = await api.get(`v1/apps/${appId}/teams/?all=1`);
            setEquipesList(res.data?.teams || []);
        } catch (error) {
            console.error('Erro ao buscar equipes', error);
        }
    };

    const handleMoveTeam = async () => {
        if (!conversa_selecionada?.id) return;
        setMovingTeam(true);
        try {
            await api.post(`v1/apps/${appId}/conversations/${conversa_selecionada.id}/move_team/`, {
                team: targetTeamId || null
            });
            setMoveTeamOpen(false);
            flashStatus({ type: 'success', message: 'Conversa movida de equipe!' });
        } catch (error) {
            console.error('Erro ao mover conversa de equipe', error);
            flashStatus({ type: 'error', message: error.response?.data?.error || 'Erro ao mover conversa de equipe!' });
        } finally {
            setMovingTeam(false);
        }
    };

    const handleNovoNegocio = async () => {
        if (!pipelineIdDefault || !stageIdDefault) {
            flashStatus({ type: 'error', message: 'Pipeline/etapa padrão não configurados' });
            return;
        }
        try {
            setSavingOutcome(true);

            // negócio novo sempre começa em branco, na primeira etapa do funil -
            // não reaproveita os dados do negócio anterior que estava aberto
            const response = await api.post(`v1/apps/${appId}/pipelines/${pipelineId}/deals/`, {
                pipeline: pipelineIdDefault,
                title: 'Novo Negócio',
                value: 0,
                description: '',
                stage: stageIdDefault
            });
            const newDeal = response.data;

            await attachDealToConversation(newDeal.id);
            onDealChange?.(newDeal);
            onDealsChanged?.();

            setForm({
                title: 'Novo Negócio',
                value: 0,
                description: '',
                stage: stageIdDefault,
                user: '',
                organization: '',
                conversation: '',
                assign: ''
            });
            limparSelecoesForm();

            flashStatus({ type: 'success', message: 'Novo negócio iniciado!' });
        } catch (error) {
            console.error('Erro ao iniciar novo negócio', error);
            flashStatus({ type: 'error', message: 'Erro ao iniciar novo negócio!' });
        } finally {
            setSavingOutcome(false);
        }
    };

    const handleUsarNegocioAntigo = async (oldDeal) => {
        try {
            setSavingOutcome(true);
            await attachDealToConversation(oldDeal.id);
            onDealChange?.(oldDeal);
            onDealsChanged?.();
            setShowDealHistory(false);
            flashStatus({ type: 'success', message: 'Negócio reativado!' });
        } catch (error) {
            console.error('Erro ao reativar negócio', error);
            flashStatus({ type: 'error', message: 'Erro ao reativar negócio!' });
        } finally {
            setSavingOutcome(false);
        }
    };

    const handleChange = () => {
        const updated = [...ordersState];
        setOrdersState(updated);
        setOrderStateAtual(updated[0]);
    };

    const handleChangeQuantity = (orderIndex, itemIndex, value) => {
        const updated = [...ordersState];
        const item = updated[orderIndex].items[itemIndex];

        // atualiza UI imediato
        item.quantity = value;
        item.total_price = (value * item.unit_price).toFixed(2);
        item.total_cost = (value * item.unit_cost).toFixed(2);
        item.profit = (item.total_price - item.total_cost).toFixed(2);

        setOrdersState(updated);
        setOrderStateAtual(updated[0]);

        // debounce por item
        if (debounceTimers.current[item.id]) {
            clearTimeout(debounceTimers.current[item.id]);
        }

        debounceTimers.current[item.id] = setTimeout(async () => {
            try {
                setLoadingItems((prev) => ({ ...prev, [item.id]: true }));

                await api.patch(`v1/apps/${appId}/items/${item.id}/`, { quantity: value });

                await fetchDeal();
            } catch (err) {
                console.error(err);
            } finally {
                setLoadingItems((prev) => ({ ...prev, [item.id]: false }));
            }
        }, 500);
    };

    const handleRemoveItem = async (orderIndex, itemIndex) => {
        const item = ordersState[orderIndex].items[itemIndex];

        try {
            setLoadingItems((prev) => ({ ...prev, [item.id]: true }));

            await api.delete(`v1/apps/${appId}/items/${item.id}/`);

            await fetchDeal();
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingItems((prev) => ({ ...prev, [item.id]: false }));
        }
    };

    const formatCurrencyBR = (value) => {
        if (value === null || value === undefined || value === '') return '';

        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(Number(value));
    };

    const parseCurrencyBR = (value) => {
        if (!value) return '';

        return value.replace(/\D/g, '').replace(/(\d{2})$/, '.$1');
    };

    function formatConversationTimestamp(isoString) {
        const date = new Date(isoString);

        const options = { timeZone: 'America/Sao_Paulo' };
        const today = new Date().toLocaleDateString('pt-BR', options);
        const yesterday = new Date(Date.now() - 86400000).toLocaleDateString('pt-BR', options);

        const dateStr = date.toLocaleDateString('pt-BR', options);

        if (dateStr === today) {
            return date.toLocaleTimeString('pt-BR', {
                ...options,
                hour: '2-digit',
                minute: '2-digit'
            });
        } else if (dateStr === yesterday) {
            return `ontem às ${date.toLocaleTimeString('pt-BR', {
                ...options,
                hour: '2-digit',
                minute: '2-digit'
            })}`;
        } else {
            return date.toLocaleDateString('pt-BR', {
                ...options,
                day: '2-digit',
                month: '2-digit'
            });
        }
    }

    const handleChangeOrderStatus = async (orderId, newStatus) => {
        try {
            console.log('Atualizando status:', orderId, newStatus);

            await api.patch(`v1/apps/${appId}/orders/${orderId}/status/`, {
                status: newStatus
            });

            // recarrega o deal inteiro (inclui histórico)
            await fetchDeal();
        } catch (err) {
            console.error('Erro ao atualizar status', err);
        }
    };

    useEffect(() => {
        // if (!appId) return;

        const interval = setInterval(() => {
            fetchDeal();
        }, 3000);

        return () => clearInterval(interval);
    }, [deal]);

    console.log(`searchAssignTerm:${JSON.stringify(searchAssignTerm)}`);

    return (
        <>
            {status.message && (
                <Alert severity={status.type} sx={{ mb: 2, position: 'absolute' }}>
                    {status.message}
                </Alert>
            )}
            {/* ===== HEADER DO DEAL ===== */}
            <Box
                sx={{
                    p: 2,
                    marginTop: 3,
                    borderBottom: `1px solid ${isDark ? '#2a3942' : '#e0e0e0'}`,
                    backgroundColor: isDark ? '#111b21' : '#f8f9fa'
                }}
            >
                {onVoltarParaChat && (
                    <IconButton onClick={onVoltarParaChat} sx={{ ml: -1, mb: 1 }}>
                        <IconArrowLeft />
                    </IconButton>
                )}
                {deal?.id && (
                    <Typography sx={{ fontSize: 11, fontFamily: 'monospace', color: isDark ? '#8696a0' : '#667781', mb: 0.5 }}>
                        {`#${String(deal.id).replace(/-/g, '').slice(-6).toUpperCase()}`}
                    </Typography>
                )}
                <TextField
                    fullWidth
                    variant="standard"
                    value={form.title}
                    onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
                    InputProps={{
                        sx: {
                            fontSize: 22,
                            fontWeight: 600,
                            color: isDark ? '#e9edef' : '#111'
                        }
                    }}
                />

                {/* <TextField
                    fullWidth
                    variant="standard"
                    value={formatCurrencyBR(form.value)}
                    onChange={(e) => {
                        const rawValue = parseCurrencyBR(e.target.value);
                        setForm((prev) => ({
                            ...prev,
                            value: rawValue
                        }));
                    }}
                    inputMode="numeric"
                /> */}
                <TextField
                    fullWidth
                    variant="standard"
                    value={formatCurrencyBR(orderStateAtual?.total_value)}
                    disabled
                    onChange={(e) => {
                        const rawValue = parseCurrencyBR(orderStateAtual?.total_value);
                        setForm((prev) => ({
                            ...prev,
                            value: rawValue
                        }));
                    }}
                    inputMode="numeric"
                />
            </Box>

            {deal?.outcome && deal.outcome !== 'open' && dismissedOutcomeBannerDealId !== deal.id && (
                <Alert
                    severity={deal.outcome === 'won' ? 'success' : 'warning'}
                    sx={{ m: 2 }}
                    onClose={() => setDismissedOutcomeBannerDealId(deal.id)}
                    action={
                        <Box display="flex" gap={1} alignItems="center">
                            <Button size="small" disabled={savingOutcome} onClick={handleReabrirNegocio}>
                                Reabrir negócio
                            </Button>
                            <Button size="small" variant="contained" disabled={savingOutcome} onClick={handleNovoNegocio}>
                                Iniciar novo negócio
                            </Button>
                        </Box>
                    }
                >
                    Negócio {deal.outcome === 'won' ? 'ganho' : 'perdido'}
                    {deal.closed_at ? ` em ${formatConversationTimestamp(deal.closed_at)}` : ''}. Continuar como pós-venda ou
                    começar uma negociação nova?
                </Alert>
            )}

            <Box sx={{ px: 2 }}>
                <Typography
                    variant="body2"
                    color="primary"
                    sx={{ cursor: 'pointer', display: 'inline-block', mb: 1 }}
                    onClick={toggleDealHistory}
                >
                    {showDealHistory ? 'Ocultar' : 'Ver'} negócios anteriores desta conversa
                </Typography>

                {showDealHistory && (
                    <Box display="flex" flexDirection="column" gap={1} mb={2}>
                        {dealHistory.length === 0 && (
                            <Typography variant="body2" color="text.secondary">
                                Nenhum outro negócio nessa conversa.
                            </Typography>
                        )}
                        {dealHistory
                            .filter((d) => d.id !== deal?.id)
                            .map((d) => (
                                <Box
                                    key={d.id}
                                    sx={{
                                        p: 1.5,
                                        borderRadius: 2,
                                        background: isDark ? '#1f2c33' : '#fff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: 1
                                    }}
                                >
                                    <Box>
                                        <Typography fontWeight={600}>
                                            {d.title}{' '}
                                            <Typography component="span" sx={{ fontSize: 11, fontFamily: 'monospace', color: 'text.secondary' }}>
                                                {`#${String(d.id).replace(/-/g, '').slice(-6).toUpperCase()}`}
                                            </Typography>
                                        </Typography>
                                        <Typography variant="caption" display="block">
                                            {d.outcome === 'won' ? 'Ganho' : d.outcome === 'lost' ? 'Perdido' : 'Em andamento'}
                                            {d.closed_at ? ` em ${formatConversationTimestamp(d.closed_at)}` : ''}
                                        </Typography>
                                    </Box>
                                    <Button size="small" disabled={savingOutcome} onClick={() => handleUsarNegocioAntigo(d)}>
                                        Usar este negócio
                                    </Button>
                                </Box>
                            ))}
                    </Box>
                )}
            </Box>

            <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                <Tab label="Resumo" />
                <Tab label={accountType === 'imobiliaria' ? 'Imóvel' : 'Produtos/Serviços'} />
                <Tab label="Proposta" />
                <Tab label="Histórico" />
            </Tabs>
            <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
                {/* ===== RESUMO ===== */}
                {tab === 0 && (
                    <Box display="flex" flexDirection="column" gap={2}>
                        {/* TODO o conteúdo aqui (cliente, organização, etc) */}
                        {/* ===== CONTEÚDO SCROLLÁVEL ===== */}
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: 'auto',
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2
                            }}
                        >
                            {/* ===== PIPELINE / STAGE ===== */}
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Box
                                    sx={{
                                        flex: 1,
                                        p: 1,
                                        borderRadius: 2,
                                        background: isDark ? '#1f2c33' : '#fff'
                                    }}
                                >
                                    <Typography fontWeight={600}>Etapa do Negócio:</Typography>
                                    <Select
                                        fullWidth
                                        size="small"
                                        value={form.stage}
                                        sx={{ mt: 1 }}
                                        onChange={(e) =>
                                            setForm((prev) => ({
                                                ...prev,
                                                stage: e.target.value
                                            }))
                                        }
                                    >
                                        {stages?.map((stage) => (
                                            <MenuItem key={stage.id} value={stage.id}>
                                                {stage.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                            </Box>
                            {conversa_selecionada?.id && (
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={openMoveTeam}
                                    sx={{ alignSelf: 'flex-start', bgcolor: '#1565c0', '&:hover': { bgcolor: '#0d47a1' } }}
                                >
                                    Mover para outra equipe
                                </Button>
                            )}

                            {deal?.id && (
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={openMovePipeline}
                                    sx={{ alignSelf: 'flex-start', bgcolor: '#1565c0', '&:hover': { bgcolor: '#0d47a1' } }}
                                >
                                    Mover para outro pipeline
                                </Button>
                            )}
                            {/* ======== STATUS VENDA ======== */}
                            <Box display="flex" flexDirection="column" gap={2}>
                                {ordersState.length === 0 && <Typography color="text.secondary">Nenhuma venda ainda</Typography>}

                                {ordersState.map((order) => (
                                    <Box
                                        key={order.id}
                                        sx={{
                                            p: 1,
                                            borderRadius: 2,
                                            background: isDark ? '#1f2c33' : '#fff'
                                        }}
                                    >
                                        <Typography fontWeight={600}>Status da Venda:</Typography>

                                        <Select
                                            fullWidth
                                            size="small"
                                            value={order.status}
                                            onChange={(e) => handleChangeOrderStatus(order.id, e.target.value)}
                                            sx={{ mt: 1 }}
                                        >
                                            <MenuItem value="draft">Rascunho</MenuItem>
                                            <MenuItem value="pending">Pendente</MenuItem>
                                            <MenuItem value="approved">Aprovado</MenuItem>
                                            <MenuItem value="paid">Pago</MenuItem>
                                            <MenuItem value="finalizada">Finalizada</MenuItem>
                                            <MenuItem value="canceled">Cancelado</MenuItem>
                                            <MenuItem value="refunded">Reembolsado</MenuItem>
                                        </Select>
                                    </Box>
                                ))}
                            </Box>

                            {/* ===== ATRIBUÍDO ==== */}
                            <Box>
                                <Box
                                    sx={{
                                        p: 1,
                                        borderRadius: 2,
                                        background: isDark ? '#1f2c33' : '#fff'
                                    }}
                                >
                                    <Typography fontWeight={600}>Atribuído</Typography>
                                    <Grid container spacing={1}>
                                        {/* Campo de busca do Atribuído */}
                                        <Grid item xs={12}>
                                            <OutlinedInput
                                                fullWidth
                                                placeholder="Buscar membro por nome ou e-mail..."
                                                value={searchAssignTerm}
                                                onChange={handleChangeSearchAssign}
                                                sx={{ mt: 1 }}
                                                startAdornment={
                                                    <InputAdornment position="start">
                                                        <IconSearch size="1.2rem" color="#666" />
                                                    </InputAdornment>
                                                }
                                            />
                                        </Grid>
                                        {/* Atribuído selecionado */}
                                        {AtribuidoSelecionado && (
                                            <Grid item xs={12}>
                                                <Typography fontWeight={600}>
                                                    Atribuído: {AtribuidoSelecionado.first_name} {AtribuidoSelecionado.last_name}
                                                </Typography>
                                            </Grid>
                                        )}
                                        {/* Lista de resultados */}
                                        {showAssignResults && (
                                            <Grid item xs={12}>
                                                <Paper elevation={3}>
                                                    <List dense>
                                                        {searchAssignResults.length === 0 && <ListItem>Nenhum membro encontrado</ListItem>}

                                                        {searchAssignResults.map((user) => (
                                                            <ListItem disablePadding key={user.id}>
                                                                <ListItemButton onClick={() => handleSelectAssign(user)}>
                                                                    <Box>
                                                                        <Typography fontWeight={500}>
                                                                            {user.first_name} {user.last_name}
                                                                        </Typography>
                                                                        <Typography variant="caption">{user.email}</Typography>
                                                                    </Box>
                                                                </ListItemButton>
                                                            </ListItem>
                                                        ))}

                                                        <ListItem disablePadding>
                                                            <ListItemButton onClick={clearAssign}>Sem Atribuído</ListItemButton>
                                                        </ListItem>
                                                    </List>
                                                </Paper>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>
                            </Box>

                            {/* ===== CLIENTE ===== */}
                            <Box>
                                <Box
                                    sx={{
                                        p: 1,
                                        borderRadius: 2,
                                        background: isDark ? '#1f2c33' : '#fff'
                                    }}
                                >
                                    <Typography fontWeight={600}>Cliente</Typography>
                                    <Grid container spacing={1}>
                                        {/* Campo de busca do Cliente */}
                                        <Grid item xs={12}>
                                            <OutlinedInput
                                                fullWidth
                                                placeholder="Buscar cliente por nome ou e-mail..."
                                                value={searchClientTerm}
                                                onChange={handleChangeSearchClient}
                                                sx={{ mt: 1 }}
                                                startAdornment={
                                                    <InputAdornment position="start">
                                                        <IconSearch size="1.2rem" color="#666" />
                                                    </InputAdornment>
                                                }
                                            />
                                        </Grid>
                                        {/* Cliente selecionado */}
                                        {clienteSelecionado && (
                                            <Grid item xs={12}>
                                                {/* <Typography variant="caption" color="text.secondary">
                                                                    Cliente selecionado:
                                                                </Typography> */}
                                                <Typography fontWeight={600}>
                                                    Cliente: {clienteSelecionado.first_name} {clienteSelecionado.last_name}
                                                </Typography>
                                                {/* <Typography variant="caption" color="text.secondary">
                                                                    {clienteSelecionado.email}
                                                                </Typography> */}
                                            </Grid>
                                        )}
                                        {/* Lista de resultados */}
                                        {showClientResults && (
                                            <Grid item xs={12}>
                                                <Paper elevation={3}>
                                                    <List dense>
                                                        {searchClientResults.length === 0 && <ListItem>Nenhum cliente encontrado</ListItem>}

                                                        {searchClientResults.map((user) => (
                                                            <ListItem disablePadding key={user.id}>
                                                                <ListItemButton onClick={() => handleSelectClient(user)}>
                                                                    <Box>
                                                                        <Typography fontWeight={500}>
                                                                            {user.first_name} {user.last_name}
                                                                        </Typography>
                                                                        <Typography variant="caption">{user.email}</Typography>
                                                                    </Box>
                                                                </ListItemButton>
                                                            </ListItem>
                                                        ))}

                                                        <ListItem disablePadding>
                                                            <ListItemButton onClick={clearClient}>Sem cliente</ListItemButton>
                                                        </ListItem>
                                                    </List>
                                                </Paper>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>
                            </Box>
                            {/* ===== ORGANIZAÇÃO ===== */}
                            <Box>
                                <Box
                                    sx={{
                                        p: 1,
                                        borderRadius: 2,
                                        background: isDark ? '#1f2c33' : '#fff'
                                    }}
                                >
                                    <Typography fontWeight={600}>Organização</Typography>
                                    <Grid container spacing={1}>
                                        {/* Campo de busca da Organização */}
                                        <Grid item xs={12}>
                                            <OutlinedInput
                                                fullWidth
                                                placeholder="Buscar organização por nome, CNPJ ou CPF..."
                                                value={searchTerm}
                                                onChange={handleChangeSearch}
                                                sx={{ mt: 1 }}
                                                startAdornment={
                                                    <InputAdornment position="start">
                                                        <IconSearch size="1.2rem" color="#666" />
                                                    </InputAdornment>
                                                }
                                            />
                                        </Grid>
                                        {/* Organização selecionada */}
                                        {organizationSelecionada && (
                                            <Grid item xs={12}>
                                                {/* <Typography variant="caption" color="text.secondary">
                                                                    Organização selecionada
                                                                </Typography> */}
                                                <Typography fontWeight={600}>Organização: {organizationSelecionada.name}</Typography>
                                            </Grid>
                                        )}
                                        {/* Lista de resultados */}
                                        {showResults && (
                                            <Grid item xs={12}>
                                                <Paper elevation={3}>
                                                    <List dense>
                                                        {searchResults.length === 0 && <ListItem>Nenhuma organização encontrada</ListItem>}

                                                        {searchResults.map((org) => (
                                                            <ListItem disablePadding key={org.id}>
                                                                <ListItemButton onClick={() => handleSelectOrganization(org)}>
                                                                    {org.name}
                                                                </ListItemButton>
                                                            </ListItem>
                                                        ))}

                                                        <ListItem disablePadding>
                                                            <ListItemButton onClick={clearOrganization}>Sem organização</ListItemButton>
                                                        </ListItem>
                                                    </List>
                                                </Paper>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>
                            </Box>

                            {/* ===== DESCRIÇÃO ===== */}
                            <Box>
                                <Box
                                    sx={{
                                        p: 1,
                                        borderRadius: 2,
                                        background: isDark ? '#1f2c33' : '#fff'
                                    }}
                                >
                                    <Typography fontWeight={600}>Descrição</Typography>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={4}
                                        size="small"
                                        sx={{ mt: 1 }}
                                        value={form.description}
                                        onChange={(e) =>
                                            setForm((prev) => ({
                                                ...prev,
                                                description: e.target.value
                                            }))
                                        }
                                    />
                                </Box>
                            </Box>

                            {/* ===== CAMPOS CUSTOMIZADOS - um por linha, igual aos demais campos ===== */}
                            {dealFieldsConfig.filter((f) => isFieldVisible(f, dealFieldsConfig, dealFields)).map((f) => (
                                <Box key={f.id}>
                                    <Box
                                        sx={{
                                            p: 1,
                                            borderRadius: 2,
                                            background: isDark ? '#1f2c33' : '#fff'
                                        }}
                                    >
                                        {f.type_field === 'boolean' ? (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={dealFields[f.name] === 'true'}
                                                        onChange={(e) =>
                                                            setDealFields({ ...dealFields, [f.name]: e.target.checked ? 'true' : 'false' })
                                                        }
                                                    />
                                                }
                                                label={f.title}
                                            />
                                        ) : f.type_field === 'select' ? (
                                            <>
                                                <Typography fontWeight={600}>{f.title}</Typography>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    size="small"
                                                    required={f.required}
                                                    sx={{ mt: 1 }}
                                                    value={dealFields[f.name] || ''}
                                                    onChange={(e) => setDealFields({ ...dealFields, [f.name]: e.target.value })}
                                                >
                                                    {(f.options || []).map((opt) => (
                                                        <MenuItem key={opt} value={opt}>
                                                            {opt}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </>
                                        ) : (
                                            <>
                                                <Typography fontWeight={600}>{f.title}</Typography>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    type={['date', 'time'].includes(f.type_field) ? f.type_field : 'text'}
                                                    required={f.required}
                                                    sx={{ mt: 1 }}
                                                    InputLabelProps={['date', 'time'].includes(f.type_field) ? { shrink: true } : undefined}
                                                    value={dealFields[f.name] || ''}
                                                    onChange={(e) => setDealFields({ ...dealFields, [f.name]: e.target.value })}
                                                />
                                            </>
                                        )}
                                    </Box>
                                </Box>
                            ))}
                            {/* ===== INFORMAÇÕES DA CONVERSA ===== */}
                            <Box>
                                <Box
                                    sx={{
                                        p: 1,
                                        borderRadius: 2,
                                        background: isDark ? '#1f2c33' : '#fff'
                                    }}
                                >
                                    <Typography fontWeight={600}>Canal</Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        sx={{ mt: 1 }}
                                        value={deal?.conversation_detail?.type || ''}
                                        disabled
                                    />
                                </Box>
                            </Box>

                            <Box>
                                <Box
                                    sx={{
                                        p: 1,
                                        borderRadius: 2,
                                        background: isDark ? '#1f2c33' : '#fff'
                                    }}
                                >
                                    <Typography fontWeight={600}>Atualizado em</Typography>
                                    <TextField fullWidth size="small" sx={{ mt: 1 }} value={formatDateBR(deal?.updated_at)} disabled />
                                </Box>
                            </Box>

                            {/* ===== TICKETS RELACIONADOS ===== */}
                            {appId && conversa_selecionada?.id && (
                                <RelatedTicketsSection
                                    appId={appId}
                                    conversationId={conversa_selecionada.id}
                                    contactId={deal?.user}
                                    organizationId={deal?.organization}
                                />
                            )}
                        </Box>
                    </Box>
                )}

                {/* ===== PRODUTOS ===== */}
                {tab === 1 && accountType !== 'imobiliaria' && (
                    <Box display="flex" flexDirection="column" gap={2}>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setProductModalTipo('produto');
                                listarProdutos();
                                setOpenProductModal(true);
                            }}
                            sx={{
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 600
                            }}
                        >
                            + Adicionar produto/serviço
                        </Button>

                        {ordersState.length === 0 && <Typography color="text.secondary">Nenhum produto adicionado</Typography>}

                        {ordersState.map((order, orderIndex) => (
                            <Box
                                key={order.id}
                                sx={{
                                    borderRadius: 3,
                                    p: 2,
                                    background: isDark ? '#1f2c33' : '#fff',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                }}
                            >
                                <Box display="flex" justifyContent="space-between" mb={2}>
                                    <Typography fontWeight={900}>Pedido</Typography>
                                    {order.status === 'draft' && <Chip label="Rascunho" size="small" />}
                                    {order.status === 'pending' && (
                                        <Chip
                                            sx={{ background: '#D0D622', color: '#708076', textTransform: 'none', fontWeight: 600 }}
                                            label="Pendente"
                                            size="small"
                                        />
                                    )}
                                    {order.status === 'approved' && (
                                        <Chip
                                            sx={{ background: '#06731B', color: '#D4D7D9', textTransform: 'none', fontWeight: 600 }}
                                            label="Aprovado"
                                            size="small"
                                        />
                                    )}
                                    {order.status === 'paid' && (
                                        <Chip
                                            sx={{ background: '#27F550', color: '#708076', textTransform: 'none', fontWeight: 600 }}
                                            label="Pago"
                                            size="small"
                                        />
                                    )}
                                    {order.status === 'canceled' && (
                                        <Chip
                                            sx={{ background: '#D64922', color: '#D4D7D9', textTransform: 'none', fontWeight: 600 }}
                                            label="Cancelado"
                                            size="small"
                                        />
                                    )}
                                    {order.status === 'refunded' && (
                                        <Chip
                                            sx={{ background: '#2192DE', color: '#D4D7D9', textTransform: 'none', fontWeight: 600 }}
                                            label="Reembolsado"
                                            size="small"
                                        />
                                    )}
                                </Box>

                                {/* TOTAL */}
                                <Box display="flex" justifyContent="space-between">
                                    <Typography>Total</Typography>
                                    {/* <Typography fontWeight={700}>R$ {order.total_value}</Typography> */}
                                    <TextField
                                        variant="standard"
                                        value={formatCurrencyBR(order?.total_value)}
                                        disabled
                                        onChange={(e) => {
                                            const rawValue = parseCurrencyBR(order?.total_value);
                                            setForm((prev) => ({
                                                ...prev,
                                                value: rawValue
                                            }));
                                        }}
                                        inputMode="numeric"
                                    />
                                </Box>

                                {order?.items?.map((item, itemIndex) => (
                                    <Box
                                        key={item.id}
                                        sx={{
                                            p: 2,
                                            mb: 2,
                                            mt: 1,
                                            borderRadius: 2,
                                            background: isDark ? '#111b21' : '#f9f9f9'
                                        }}
                                    >
                                        {/* HEADER */}
                                        <Box display="flex" justifyContent="space-between">
                                            <Typography fontWeight={600}>{item.product_name}</Typography>

                                            <IconButton
                                                size="small"
                                                onClick={() => handleRemoveItem(orderIndex, itemIndex)}
                                                disabled={loadingItems[item.id]}
                                            >
                                                {loadingItems[item.id] ? '...' : '❌'}
                                            </IconButton>
                                        </Box>

                                        {/* VARIAÇÃO (produto) ou rótulo de Serviço (sem variação) */}
                                        <Typography variant="caption" color="text.secondary">
                                            {item.variacao_nome || 'Serviço'}
                                        </Typography>

                                        {/* CONTROLES */}
                                        <Box display="flex" gap={2} mt={1} alignItems="center">
                                            <TextField
                                                disabled={loadingItems[item.id]}
                                                type="number"
                                                size="small"
                                                label="Qtd"
                                                value={item.quantity}
                                                onChange={(e) => handleChangeQuantity(orderIndex, itemIndex, Number(e.target.value))}
                                                sx={{ width: 80 }}
                                            />

                                            <Typography>Valor unitário: R$ {item.unit_price}</Typography>

                                            <Typography fontWeight={600}>Total: R$ {item.total_price}</Typography>
                                        </Box>

                                        {/* LUCRO */}
                                        <Typography variant="caption" color="success.main">
                                            Lucro: R$ {item.profit}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        ))}

                        {/* ===== CONTRATOS DE SERVIÇO ===== */}
                        {servicesEnabled && (
                            <Box mt={2}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography fontWeight={900}>Contratos de Serviço</Typography>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => setOpenContratoServicoForm(true)}
                                        sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
                                    >
                                        + Vincular contrato
                                    </Button>
                                </Box>

                                {contratosServico.length === 0 && (
                                    <Typography color="text.secondary">Nenhum contrato vinculado</Typography>
                                )}

                                {contratosServico.map((contrato) => (
                                    <Box
                                        key={contrato.id}
                                        onClick={() => setContratoServicoDetailId(contrato.id)}
                                        sx={{
                                            borderRadius: 3,
                                            p: 2,
                                            mb: 1,
                                            cursor: 'pointer',
                                            background: isDark ? '#1f2c33' : '#fff',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                        }}
                                    >
                                        <Box display="flex" justifyContent="space-between">
                                            <Typography fontWeight={600}>{contrato.servico_detail?.nome}</Typography>
                                            <Chip label={contrato.status_display} size="small" />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary">
                                            R$ {contrato.valor} · Vencimento: {contrato.data_vencimento || '-'}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        )}
                    </Box>
                )}

                {/* ===== PROPOSTA ===== */}
                {tab === 2 && (
                    <Box display="flex" flexDirection="column" gap={2}>
                        <Button
                            variant="contained"
                            onClick={() => setOpenPropostaForm(true)}
                            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, alignSelf: 'flex-start' }}
                        >
                            + Criar proposta
                        </Button>

                        {openPropostaForm && (
                            <Box
                                sx={{
                                    borderRadius: 3,
                                    p: 2,
                                    background: isDark ? '#1f2c33' : '#fff',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                }}
                            >
                                <Typography fontWeight={700} mb={2}>
                                    Nova Proposta
                                </Typography>
                                <Box display="flex" flexDirection="column" gap={2}>
                                    <TextField
                                        label="Título"
                                        value={propostaForm.titulo}
                                        onChange={(e) => setPropostaForm({ ...propostaForm, titulo: e.target.value })}
                                        fullWidth
                                    />

                                    {propostaFieldsConfig.length > 0 && (
                                        <Grid container spacing={2}>
                                            {propostaFieldsConfig
                                                .filter((f) => isFieldVisible(f, propostaFieldsConfig, propostaForm.fields))
                                                .map((f) => (
                                                    <CustomFieldInput
                                                        key={f.id}
                                                        field={f}
                                                        value={propostaForm.fields[f.name]}
                                                        onChange={(value) =>
                                                            setPropostaForm({
                                                                ...propostaForm,
                                                                fields: { ...propostaForm.fields, [f.name]: value }
                                                            })
                                                        }
                                                    />
                                                ))}
                                        </Grid>
                                    )}

                                    <Box display="flex" justifyContent="flex-end" gap={1}>
                                        <Button onClick={() => setOpenPropostaForm(false)}>Cancelar</Button>
                                        <Button variant="contained" onClick={handleCreateProposta} disabled={savingProposta}>
                                            Salvar
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        )}

                        {propostas.length === 0 && <Typography color="text.secondary">Nenhuma proposta criada</Typography>}

                        {propostas.map((proposta) => (
                            <Box
                                key={proposta.id}
                                sx={{
                                    borderRadius: 3,
                                    p: 2,
                                    background: isDark ? '#1f2c33' : '#fff',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                }}
                            >
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography fontWeight={600}>{proposta.titulo || 'Proposta sem título'}</Typography>
                                    <Chip label={proposta.status_display} size="small" />
                                </Box>
                                <Box display="flex" gap={1} mt={1}>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() => handleGerarPdfProposta(proposta.id)}
                                        disabled={Boolean(propostaActionLoading[proposta.id])}
                                    >
                                        {propostaActionLoading[proposta.id] === 'pdf' ? 'Gerando...' : proposta.document ? 'Gerar PDF de novo' : 'Gerar PDF'}
                                    </Button>
                                    {proposta.document && (
                                        <>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={() => handleAbrirPreviewProposta(proposta, false)}
                                                disabled={Boolean(propostaActionLoading[proposta.id])}
                                            >
                                                Visualizar
                                            </Button>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={() => handleAbrirPreviewProposta(proposta, true)}
                                                disabled={Boolean(propostaActionLoading[proposta.id])}
                                            >
                                                {propostaActionLoading[proposta.id] === 'send' ? 'Enviando...' : 'Revisar e enviar'}
                                            </Button>
                                        </>
                                    )}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                )}

                {/* ===== PRÉVIA DO PDF DA PROPOSTA (visualizar / revisar antes de enviar) ===== */}
                <Dialog
                    open={Boolean(previewProposta)}
                    onClose={() => {
                        setPreviewProposta(null);
                        setPreviewParaEnviar(false);
                    }}
                    fullWidth
                    maxWidth="md"
                    PaperProps={{ sx: { height: '90vh' } }}
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {previewParaEnviar ? 'Revisar antes de enviar' : 'Prévia da Proposta'}
                        <IconButton
                            size="small"
                            onClick={() => {
                                setPreviewProposta(null);
                                setPreviewParaEnviar(false);
                            }}
                        >
                            <IconX size={18} />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
                        {previewParaEnviar && (
                            <Alert severity="info" sx={{ borderRadius: 0 }}>
                                Confira o PDF abaixo antes de mandar pro cliente - depois de enviado não dá pra desfazer.
                            </Alert>
                        )}
                        {previewProposta?.document_detail?.r2_key ? (
                            <Box
                                component="iframe"
                                title="Prévia da Proposta"
                                src={getPrivateMediaUrl(previewProposta.document_detail.r2_key)}
                                sx={{ flex: 1, border: 'none', width: '100%' }}
                            />
                        ) : (
                            <Box display="flex" alignItems="center" justifyContent="center" flex={1}>
                                <Typography color="text.secondary">PDF ainda não disponível pra essa proposta.</Typography>
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setPreviewProposta(null);
                                setPreviewParaEnviar(false);
                            }}
                        >
                            {previewParaEnviar ? 'Cancelar' : 'Fechar'}
                        </Button>
                        {previewParaEnviar && (
                            <Button
                                variant="contained"
                                onClick={handleConfirmarEnvioProposta}
                                disabled={Boolean(previewProposta && propostaActionLoading[previewProposta.id])}
                            >
                                {previewProposta && propostaActionLoading[previewProposta.id] === 'send' ? 'Enviando...' : 'Confirmar e enviar'}
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>

                {/* ===== IMÓVEL (contas imobiliária) ===== */}
                {tab === 1 && accountType === 'imobiliaria' && (
                    <Box display="flex" flexDirection="column" gap={2}>
                        {!linkedImovel && (
                            <Box
                                sx={{
                                    borderRadius: 3,
                                    p: 2,
                                    textAlign: 'center',
                                    background: isDark ? '#1f2c33' : '#fff'
                                }}
                            >
                                <Typography color="text.secondary" mb={2}>
                                    Nenhum imóvel vinculado a este negócio
                                </Typography>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        listarImoveis();
                                        setOpenImovelPicker(true);
                                    }}
                                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
                                >
                                    + Vincular imóvel
                                </Button>
                            </Box>
                        )}

                        {linkedImovel && (
                            <Box
                                sx={{
                                    borderRadius: 3,
                                    p: 2,
                                    display: 'flex',
                                    gap: 2,
                                    background: isDark ? '#1f2c33' : '#fff',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                }}
                            >
                                {linkedImovel.imagens?.[0]?.url && (
                                    <Box
                                        component="img"
                                        src={getPrivateMediaUrl(linkedImovel.imagens[0].url)}
                                        sx={{ width: 88, height: 88, borderRadius: 2, objectFit: 'cover', flexShrink: 0 }}
                                    />
                                )}
                                <Box flex={1}>
                                    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                                        <Typography fontWeight={700}>{linkedImovel.titulo}</Typography>
                                        <Chip size="small" label={IMOVEL_STATUS_LABELS[linkedImovel.status] || linkedImovel.status} />
                                    </Box>
                                    <Typography variant="body2" color="text.secondary">
                                        {linkedImovel.endereco || linkedImovel.bairro || ''}
                                    </Typography>
                                    <Typography fontWeight={600} mt={0.5}>
                                        {formatImovelPrice(linkedImovel.valor, linkedImovel.valor_a_partir_de)}
                                    </Typography>
                                    <Box display="flex" gap={1} mt={1}>
                                        <Button
                                            size="small"
                                            onClick={() => {
                                                listarImoveis();
                                                setOpenImovelPicker(true);
                                            }}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            Trocar
                                        </Button>
                                        <Button size="small" color="error" onClick={handleUnlinkImovel} sx={{ textTransform: 'none' }}>
                                            Remover
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        )}

                        {/* ===== VISITAS ===== */}
                        <Box sx={{ borderRadius: 3, p: 2, background: isDark ? '#1f2c33' : '#fff' }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography fontWeight={700}>Visitas</Typography>
                                <Button
                                    size="small"
                                    disabled={!linkedImovel}
                                    onClick={() => setOpenVisitaModal(true)}
                                    sx={{ textTransform: 'none' }}
                                >
                                    + Agendar visita
                                </Button>
                            </Box>

                            {!linkedImovel && (
                                <Typography variant="body2" color="text.secondary">
                                    Vincule um imóvel primeiro
                                </Typography>
                            )}

                            {linkedImovel && visitas.length === 0 && (
                                <Typography variant="body2" color="text.secondary">
                                    Nenhuma visita agendada
                                </Typography>
                            )}

                            {visitas.map((v) => (
                                <Box
                                    key={v.id}
                                    sx={{
                                        p: 1.5,
                                        mt: 1,
                                        borderRadius: 2,
                                        background: isDark ? '#111b21' : '#f9f9f9',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Box>
                                        <Typography variant="body2">{formatConversationTimestamp(v.start)}</Typography>
                                        {v.feedback && (
                                            <Typography variant="caption" color="text.secondary">
                                                {v.feedback}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Chip size="small" label={VISITA_STATUS_LABELS[v.status] || v.status} />
                                </Box>
                            ))}
                        </Box>

                        {/* ===== CONTRATOS ===== */}
                        <Box sx={{ borderRadius: 3, p: 2, background: isDark ? '#1f2c33' : '#fff' }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography fontWeight={700}>Contratos</Typography>
                                <Button
                                    size="small"
                                    disabled={!linkedImovel}
                                    onClick={() => setOpenContratoModal(true)}
                                    sx={{ textTransform: 'none' }}
                                >
                                    + Criar contrato
                                </Button>
                            </Box>

                            {!linkedImovel && (
                                <Typography variant="body2" color="text.secondary">
                                    Vincule um imóvel primeiro
                                </Typography>
                            )}

                            {linkedImovel && contratos.length === 0 && (
                                <Typography variant="body2" color="text.secondary">
                                    Nenhum contrato criado
                                </Typography>
                            )}

                            {contratos.map((c) => (
                                <Box
                                    key={c.id}
                                    sx={{
                                        p: 1.5,
                                        mt: 1,
                                        borderRadius: 2,
                                        background: isDark ? '#111b21' : '#f9f9f9',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Box>
                                        <Typography variant="body2">
                                            {CONTRATO_TIPO_LABELS[c.tipo] || c.tipo} - {formatCurrencyBRL(c.valor)}
                                        </Typography>
                                    </Box>
                                    <Chip size="small" label={CONTRATO_STATUS_LABELS[c.status] || c.status} />
                                </Box>
                            ))}
                        </Box>
                    </Box>
                )}

                {/* ===== HISTÓRICO ===== */}
                {tab === 3 && (
                    <Box display="flex" flexDirection="column" gap={2}>
                        {ordersState.length === 0 && <Typography color="text.secondary">Sem histórico</Typography>}

                        {ordersState.map((order) => (
                            <Box
                                key={order.id}
                                sx={{
                                    borderRadius: 3,
                                    p: 2,
                                    background: isDark ? '#1f2c33' : '#fff'
                                }}
                            >
                                <Typography fontWeight={600} mb={2}>
                                    Histórico do Pedido
                                </Typography>

                                {order.history?.length === 0 && <Typography color="text.secondary">Nenhuma alteração ainda</Typography>}

                                {order.history?.map((h) => (
                                    <Box
                                        key={h.id}
                                        sx={{
                                            p: 2,
                                            mb: 1,
                                            borderRadius: 2,
                                            background: isDark ? '#111b21' : '#f9f9f9'
                                        }}
                                    >
                                        <Typography fontWeight={600}>
                                            {h.status === 'draft' && <Typography fontWeight={600}>Status: Rascunho</Typography>}
                                            {h.status === 'pending' && <Typography fontWeight={600}>Status: Pendente</Typography>}
                                            {h.status === 'approved' && <Typography fontWeight={600}>Status: Aprovado</Typography>}
                                            {h.status === 'paid' && <Typography fontWeight={600}>Status: Pago</Typography>}
                                            {h.status === 'finalizada' && <Typography fontWeight={600}>Status: Finalizada</Typography>}
                                            {h.status === 'canceled' && <Typography fontWeight={600}>Status: Cancelado</Typography>}
                                        </Typography>

                                        <Typography fontWeight={600}>Por: {h.changed_by_name || 'Sistema'}</Typography>

                                        <Typography variant="caption" display="block">
                                            {formatConversationTimestamp(h.created_at)}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>
            <Dialog open={openProductModal} onClose={() => setOpenProductModal(false)} fullWidth maxWidth="sm">
                <DialogTitle>Adicionar {productModalTipo === 'produto' ? 'Produto' : 'Serviço'} ao Pedido</DialogTitle>

                <DialogContent>
                    {/* TIPO */}
                    <Box display="flex" gap={1} mb={2}>
                        <Button
                            size="small"
                            variant={productModalTipo === 'produto' ? 'contained' : 'outlined'}
                            onClick={() => {
                                setProductModalTipo('produto');
                                setSelectedServico(null);
                                listarProdutos();
                            }}
                            sx={{ borderRadius: 2, textTransform: 'none' }}
                        >
                            Produto
                        </Button>
                        <Button
                            size="small"
                            variant={productModalTipo === 'servico' ? 'contained' : 'outlined'}
                            onClick={() => {
                                setProductModalTipo('servico');
                                setSelectedProduct(null);
                                setSelectedVariacao(null);
                                listarServicos();
                            }}
                            sx={{ borderRadius: 2, textTransform: 'none' }}
                        >
                            Serviço
                        </Button>
                    </Box>

                    {productModalTipo === 'produto' ? (
                        <>
                            {/* LISTA PRODUTOS */}
                            <List>
                                {products.map((p) => (
                                    <ListItemButton key={p.id} onClick={() => handleSelectProduct(p)}>
                                        {p.nome}
                                    </ListItemButton>
                                ))}
                            </List>

                            {/* VARIAÇÕES */}
                            {selectedProduct && (
                                <>
                                    <Typography mt={2}>Variações</Typography>
                                    <List>
                                        {selectedProduct.variacoes.map((v) => (
                                            <ListItemButton key={v.id} onClick={() => setSelectedVariacao(v)}>
                                                {v.nome_variacao} - R$ {v.valor_venda}
                                            </ListItemButton>
                                        ))}
                                    </List>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            {/* LISTA SERVIÇOS */}
                            {servicos.length === 0 && (
                                <Typography color="text.secondary">Nenhum serviço ativo cadastrado</Typography>
                            )}
                            <List>
                                {servicos.map((s) => (
                                    <ListItemButton
                                        key={s.id}
                                        selected={selectedServico?.id === s.id}
                                        onClick={() => setSelectedServico(s)}
                                    >
                                        {s.nome} - R$ {s.preco}
                                    </ListItemButton>
                                ))}
                            </List>
                        </>
                    )}

                    {/* QUANTIDADE */}
                    {(selectedVariacao || selectedServico) && (
                        <TextField
                            fullWidth
                            type="number"
                            label="Quantidade"
                            value={quantity}
                            onChange={(e) => setQuantity(Number(e.target.value))}
                            sx={{ mt: 2 }}
                        />
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenProductModal(false)}>Cancelar</Button>
                    <Button
                        variant="contained"
                        onClick={handleAddProduct}
                        disabled={productModalTipo === 'produto' ? !selectedVariacao : !selectedServico}
                    >
                        Adicionar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={movePipelineOpen} onClose={() => setMovePipelineOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>Mover negócio para outro pipeline</DialogTitle>
                <DialogContent>
                    <TextField
                        select
                        fullWidth
                        label="Pipeline de destino"
                        value={targetPipelineId}
                        onChange={(e) => handleChangeTargetPipeline(e.target.value)}
                        sx={{ mt: 1, mb: 2 }}
                    >
                        {pipelinesList.length === 0 ? (
                            <MenuItem disabled>Nenhum outro pipeline cadastrado</MenuItem>
                        ) : (
                            pipelinesList.map((p) => (
                                <MenuItem key={p.id} value={p.id}>
                                    {p.name}
                                </MenuItem>
                            ))
                        )}
                    </TextField>

                    {targetPipelineId && (
                        <TextField
                            select
                            fullWidth
                            label="Etapa inicial"
                            value={targetStageId}
                            onChange={(e) => setTargetStageId(e.target.value)}
                        >
                            {targetStages.map((s) => (
                                <MenuItem key={s.id} value={s.id}>
                                    {s.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setMovePipelineOpen(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleMovePipeline} disabled={!targetPipelineId || movingPipeline}>
                        {movingPipeline ? 'Movendo...' : 'Mover'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={moveTeamOpen} onClose={() => setMoveTeamOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>Mover conversa para outra equipe</DialogTitle>
                <DialogContent>
                    <TextField
                        select
                        fullWidth
                        label="Equipe de destino"
                        value={targetTeamId}
                        onChange={(e) => setTargetTeamId(e.target.value)}
                        sx={{ mt: 1 }}
                        helperText="Deixe em branco pra tirar a conversa de qualquer equipe (fica visível pra conta inteira)."
                    >
                        <MenuItem value="">Nenhuma (visível pra todos)</MenuItem>
                        {equipesList.map((eq) => (
                            <MenuItem key={eq.id} value={eq.id}>
                                {eq.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setMoveTeamOpen(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleMoveTeam} disabled={movingTeam}>
                        {movingTeam ? 'Movendo...' : 'Mover'}
                    </Button>
                </DialogActions>
            </Dialog>

            {openContratoServicoForm && (
                <ContratoFormDrawer
                    appId={appId}
                    dealId={deal?.id}
                    onClose={() => setOpenContratoServicoForm(false)}
                    onSaved={() => {
                        setOpenContratoServicoForm(false);
                        fetchContratosServico();
                    }}
                />
            )}

            {contratoServicoDetailId && (
                <ContratoDetailDrawer
                    appId={appId}
                    contratoId={contratoServicoDetailId}
                    onClose={() => setContratoServicoDetailId(null)}
                    onChanged={fetchContratosServico}
                />
            )}

            <Dialog open={openImovelPicker} onClose={() => setOpenImovelPicker(false)} fullWidth maxWidth="sm">
                <DialogTitle>Vincular imóvel</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Buscar por título..."
                        value={imovelSearchTerm}
                        onChange={(e) => setImovelSearchTerm(e.target.value)}
                        sx={{ mt: 1, mb: 1 }}
                    />
                    <List>
                        {imoveisFiltrados.map((i) => (
                            <ListItemButton key={i.id} onClick={() => handleLinkImovel(i)}>
                                <Box>
                                    <Typography>{i.titulo}</Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {formatImovelPrice(i.valor, i.valor_a_partir_de)}
                                    </Typography>
                                </Box>
                            </ListItemButton>
                        ))}
                        {imoveisFiltrados.length === 0 && (
                            <Typography color="text.secondary" p={2}>
                                Nenhum imóvel encontrado
                            </Typography>
                        )}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenImovelPicker(false)}>Cancelar</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openVisitaModal} onClose={() => setOpenVisitaModal(false)} fullWidth maxWidth="sm">
                <DialogTitle>Agendar visita</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2} mt={1}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label="Início"
                            InputLabelProps={{ shrink: true }}
                            value={visitaForm.start}
                            onChange={(e) => setVisitaForm((prev) => ({ ...prev, start: e.target.value }))}
                        />
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label="Fim"
                            InputLabelProps={{ shrink: true }}
                            value={visitaForm.end}
                            onChange={(e) => setVisitaForm((prev) => ({ ...prev, end: e.target.value }))}
                        />
                        <Select
                            fullWidth
                            size="small"
                            value={visitaForm.status}
                            onChange={(e) => setVisitaForm((prev) => ({ ...prev, status: e.target.value }))}
                        >
                            {Object.entries(VISITA_STATUS_LABELS).map(([value, label]) => (
                                <MenuItem key={value} value={value}>
                                    {label}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenVisitaModal(false)}>Cancelar</Button>
                    <Button variant="contained" disabled={!visitaForm.start || !visitaForm.end} onClick={handleCreateVisita}>
                        Agendar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openContratoModal} onClose={() => setOpenContratoModal(false)} fullWidth maxWidth="sm">
                <DialogTitle>Criar contrato</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2} mt={1}>
                        <Select
                            fullWidth
                            size="small"
                            value={contratoForm.tipo}
                            onChange={(e) => setContratoForm((prev) => ({ ...prev, tipo: e.target.value }))}
                        >
                            {Object.entries(CONTRATO_TIPO_LABELS).map(([value, label]) => (
                                <MenuItem key={value} value={value}>
                                    {label}
                                </MenuItem>
                            ))}
                        </Select>
                        <TextField
                            fullWidth
                            label="Valor"
                            value={contratoForm.valor}
                            onChange={(e) => setContratoForm((prev) => ({ ...prev, valor: e.target.value }))}
                        />
                        <TextField
                            fullWidth
                            type="date"
                            label="Data de início"
                            InputLabelProps={{ shrink: true }}
                            value={contratoForm.data_inicio}
                            onChange={(e) => setContratoForm((prev) => ({ ...prev, data_inicio: e.target.value }))}
                        />
                        <TextField
                            fullWidth
                            type="date"
                            label="Data de fim"
                            InputLabelProps={{ shrink: true }}
                            value={contratoForm.data_fim}
                            onChange={(e) => setContratoForm((prev) => ({ ...prev, data_fim: e.target.value }))}
                        />
                        <Select
                            fullWidth
                            size="small"
                            value={contratoForm.status}
                            onChange={(e) => setContratoForm((prev) => ({ ...prev, status: e.target.value }))}
                        >
                            {Object.entries(CONTRATO_STATUS_LABELS).map(([value, label]) => (
                                <MenuItem key={value} value={value}>
                                    {label}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenContratoModal(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleCreateContrato}>
                        Criar
                    </Button>
                </DialogActions>
            </Dialog>
            {/* ===== FOOTER ===== */}
            <Box
                sx={{
                    p: 2,
                    borderTop: `1px solid ${isDark ? '#2a3942' : '#e0e0e0'}`,
                    backgroundColor: isDark ? '#111b21' : '#f8f9fa'
                }}
            >
                <Button
                    sx={{
                        backgroundColor: '#32CD32',
                        textTransform: 'none'
                    }}
                    fullWidth
                    variant="contained"
                    onClick={handleSaveDeal}
                >
                    Salvar alterações
                </Button>
            </Box>
        </>
    );
};

export default DadosDeal;
